if (!customElements.get("tabs-with-content")) {
  customElements.define(
    "tabs-with-content",
    class TabsWithContent extends HTMLElement {
      constructor() {
        super();

        this.tabs = this.querySelectorAll(`.tab-button`);
        this.contents = this.querySelectorAll(`.tab-content`);
      }

      connectedCallback() {
        this.setupListeners();
      }

      setupListeners() {
        if (this.tabs.length < 2 || this.contents.length < 2) return;
        this.tabs.forEach((tab) => {
          tab.addEventListener("click", this.onTabClick.bind(this));
        });
      }

      onTabClick(e) {
        const index = e.currentTarget.dataset.index;
        this.tabs.forEach((tab) => {
          if (tab.classList.contains("tab-button--active")) {
            tab.classList.remove("tab-button--active");
          }
        });
        e.currentTarget.classList.add("tab-button--active");
        this.contents.forEach((content) => {
          if (content.classList.contains("tab-content--active")) {
            content.classList.remove("tab-content--active");
          }
        });
        this.querySelector(`.tab-content[data-index="${index}"]`).classList.add("tab-content--active");
      }
    }
  );
}
